import { MInput, MDatePicker, MTextArea, MButton } from '@Components/Base';
import MTimePicker from '@Components/Filters/TimePicker/MTimePicker';

import { Col, Flex, Form, Modal, Row } from 'antd';
import Text from 'antd/es/typography/Text';

import { FormikProps } from 'formik';
import { UnlockPricingFormValues } from '../UnlockPricingDialog';

import { ButtonsFooter } from '../../../common/ButtonsFooter';

import styles from './UnlockPricingDialog.module.css';

interface UnlockPricingDesktopProps {
  isOpen: boolean;
  formik: FormikProps<UnlockPricingFormValues>;
  onCancel: () => void;
}

const UnlockPricingDesktop: React.FC<UnlockPricingDesktopProps> = ({
  formik,
  isOpen,
  onCancel,
}) => {
  const customButtons = (
    <ButtonsFooter>
      <MButton
        onClick={() => {
          onCancel?.();
        }}
        type="tertiary"
      >
        Cancel
      </MButton>
      <MButton
        type="primary"
        disabled={!formik.isValid}
        onClick={() => {
          formik.submitForm();
        }}
      >
        Unlock
      </MButton>
    </ButtonsFooter>
  );

  return (
    <Modal
      open={isOpen}
      className={styles.modal}
      footer={customButtons}
      width={600}
      title="Unlock Pricing"
      onCancel={() => {
        onCancel?.();
      }}
    >
      <form
        noValidate
        onSubmit={(e) => {
          e.nativeEvent.preventDefault();
          formik.submitForm();
        }}
        className={styles.unlockPricingDialog}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label="Expected Total Amount (AED)"
              className={styles.formItem}
            >
              <MInput name="expectedAmount" placeholder="Enter Amount" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Expiry Date" className={styles.formItem}>
              <MDatePicker
                name="expiryDate"
                placeholder="DD/MM/YYYY"
                onChange={(selectValue) => {
                  formik.setFieldValue('expiryDate', selectValue);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Expiry Time" className={styles.formItem}>
              <MTimePicker
                value={formik.values.expiryTime}
                showSecond={false}
                onChange={(selectValue) => {
                  formik.setFieldValue('expiryTime', selectValue);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Remarks" className={styles.formItem}>
              <MTextArea
                name="remarks"
                maxLength={20}
                title="Remarks"
                placeholder="Insert Remarks"
                onChange={(value) => {
                  formik.setFieldValue('remarks', value.target.value);
                }}
              />
              <Flex justify="end">
                {formik.values.remarks && (
                  <Text type="secondary">
                    {formik.values.remarks?.length}/20
                  </Text>
                )}
              </Flex>
              {formik.errors.remarks && (
                <Flex justify="end">
                  <Text type="danger">{formik.errors.remarks}</Text>
                </Flex>
              )}
            </Form.Item>
          </Col>
        </Row>
      </form>
    </Modal>
  );
};

export default UnlockPricingDesktop;
